import type { GiteaWorkflowStatusKey, IntegrationHealthStatus } from "../types/dashboard.types";

export const normalizeStatusValue = (value: unknown): string =>
  String(value ?? "")
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, "_");

export const giteaStatusKey = (raw: unknown): GiteaWorkflowStatusKey => {
  const normalized = String(raw ?? "").trim().toLowerCase();
  if (normalized === "new" || normalized === "nieuw") return "new";
  if (normalized === "in progress" || normalized === "in behandeling") return "inProgress";
  if (normalized === "on hold" || normalized === "in wacht") return "onHold";
  if (normalized === "closed" || normalized === "gesloten") return "closed";
  if (normalized === "rejected" || normalized === "afgewezen") return "rejected";
  if (normalized === "open") return "open";
  return "unknown";
};

export const getApiStatus = (error: unknown): number | undefined => {
  const candidate = error as { response?: { status?: unknown } };
  return typeof candidate?.response?.status === "number" ? candidate.response.status : undefined;
};

export const safeErrorText = (error: unknown, fallback = "Something went wrong."): string => {
  if (!error) return fallback;
  if (typeof error === "string") return error;
  if (error instanceof Error && error.message) return error.message;
  const record = error as { message?: unknown; title?: unknown; response?: { data?: { message?: unknown; error?: unknown; title?: unknown } } };
  const data = record.response?.data;
  for (const value of [data?.message, data?.error, data?.title, record.message, record.title]) {
    if (typeof value === "string" && value.trim()) return value.trim();
  }
  return fallback;
};

export const healthBadgeClass = (status: IntegrationHealthStatus): string => {
  if (status === "online") return "bg-emerald-50 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-100";
  if (status === "warning") return "bg-amber-50 text-amber-800 dark:bg-amber-900/30 dark:text-amber-100";
  if (status === "disabled") return "bg-slate-100 text-slate-700 dark:bg-slate-800/40 dark:text-slate-200";
  return "bg-rose-50 text-rose-800 dark:bg-rose-900/30 dark:text-rose-100";
};
